import Vue from 'vue';
import VueResource from 'vue-resource';
Vue.use(VueResource);

export default {

    saveLocallyNewConfig(context, payload) {
        context.commit('CHANGE_FLEET_DISPLAY_CONFIG', payload);
    },

    setSelectedFleetForDataDisplay(context, value) {
        context.commit('SET_SELECTED_FLEET_FOR_DATA_DISPLAY', value);
    },

    setNumberVehiclesToInspect(context, value) {
        context.commit('SET_NUMBER_VEHICLES_TO_INSPECT', value);
    },

    setNumberRequests(context, value) {
        context.commit('SET_NUMBER_REQUESTS', value);
    },
    setExtremeVehiculesInspectionCount(context, value) {
        context.commit('SET_EXTREME_VEHICULES_INSPECTION_COUNT', value);
    }

};



// WEBPACK FOOTER //
// ./src/store/actions.js